export enum EditLeadModalTab {
    Detail = 'detail',
    Customer = 'customer',
    Contact = 'contact',
    CreateOffer = 'create_offer',
    Offers = 'offers',
    MailTemplate = 'mail_template',
}